(function () {
    'use strict';

    angular
        .module('tfc.retailer.Filter')
        .factory('BaseFilter', FilterClass);

    function FilterClass() {

        function Filter(filterName) {
            if (!(this instanceof Filter)) return new Filter(filterName);

            this._selectedItem = null;
            this._brandKey = null;
            this._filterName = filterName;
            this._data = [];
        }

        _.extend(Filter.prototype, {
            getData: function () {
                return this._data;
            },
            setData: function (data) {
                this._data = data;
            },
            getOptionString: unimplemented('getOptionString'),
            isDisabled: function () {
                return this._data && this._data.length === 0;
            },
            isVisible: unimplemented('isVisible'),
            setSelectedItem: function (selected) {
                this._selectedItem = selected;
            },
            getSelectedItem: function () {
                return this._selectedItem;
            },
            getEventDetails: function () {
                return {
                    eventCategory: this._brandKey,
                    eventAction: this._filterName,
                    eventLabel: this._selectedItem && this._selectedItem.display
                }
            },
            setBrandKey : function (brandKey) {
                this._brandKey = brandKey
            },
            getSelectedItemAttribute: function (attribute) {
                return this._selectedItem && this._selectedItem[attribute];
            }
        });

        return Filter;

        function unimplemented(method) {
            return function () {
                console.error(new Error('#' + method + ' not implemented for ' + this._filterName));
            };
        }

    }

}());